import { SAVE_TTD_SEGMENT_REMODEL_CONFIGURATION } from '../queries';
import { useMutation } from '@apollo/client';

/**
 * Custom hook to save TTD segment remodel configuration
 * @returns {Array} [saveConfig, { loading, error, data }]
 */
const useSaveSegmentRemodelConfig = () => {
  const [saveConfig, { loading, error, data }] = useMutation(
    SAVE_TTD_SEGMENT_REMODEL_CONFIGURATION
  );

  /**
   * Save segment remodel configuration
   * @param {Object} params - Configuration parameters
   * @param {string} params.segmentId - The segment ID
   * @param {number} params.remodelInterval - Remodel interval in days
   * @param {boolean} params.enabled - Whether remodeling is enabled
   * @param {string|null} params.optimizedAudienceId - Optimized audience ID (null to clear)
   * @returns {Promise} Mutation promise
   */
  const save = async ({
    segmentId,
    remodelInterval,
    enabled,
    optimizedAudienceId,
  }) => {
    return saveConfig({
      variables: {
        segmentId,
        remodelInterval,
        enabled,
        optimizedAudienceId: optimizedAudienceId ?? null,
      },
    });
  };

  return [
    save,
    {
      loading,
      error,
      data: data?.saveTtdSegmentRemodelConfiguration,
    },
  ];
};

export default useSaveSegmentRemodelConfig;
